<template>
  <FilterMultiChip
    icon="grid"
    :is-text="isText"
    :label="resolvedLabel"
    :items="items"
    :value="value || []"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterMultiChip from '@/components/filters/FilterMultiChip';
import { CATEGORIES_VALUES } from '@/models/search-filters';

/**
 * Procurement-categories dimension chip. Presentational: `:value` (array) in, `change` out —
 * the consumer decides how to persist it (e.g. tenders folds it into its advanced-filters payload).
 * Builds options from CATEGORIES_VALUES + i18n.
 */
export default {
  name: 'CategoriesChip',
  components: { FilterMultiChip },
  props: {
    value: { type: Array, default: () => [] },
    // Defaults to the tenders "Categories" label; overridable so other pages can relabel.
    label: { type: String, default: null },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    resolvedLabel() {
      return this.label || this.$t('search-filters.contract-type.name');
    },
    items() {
      return CATEGORIES_VALUES.map((v) => ({ value: v, text: this.$t(`search-filters.contract-type.values.${v}`) }));
    },
  },
};
</script>
